"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgUsage(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    fill: "none",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M2 21.5c0-.276.11-.417.387-.417h19.308c.276 0 .305.417.305.417 0 .276-.083.5-.36.5H2.36c-.417-.083-.36-.5-.36-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75 17.333a.5.5 0 01.5-.5h2.5a.5.5 0 01.5.5V21.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5v-4.167zm1 .5V21h1.5v-3.167h-1.5zM7.75 13.167a.5.5 0 01.5-.5h2.5a.5.5 0 01.5.5V21.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5v-8.333zm1 .5V21h1.5v-7.333h-1.5zM12.75 14.833a.5.5 0 01.5-.5h2.5a.5.5 0 01.5.5V21.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5v-6.667zm1 .5V21h1.5v-5.667h-1.5zM17.75 9a.5.5 0 01.5-.5h2.5a.5.5 0 01.5.5v12.5a.5.5 0 01-.5.5h-2.5a.5.5 0 01-.5-.5V9zm1 .5V21h1.5V9.5h-1.5zM4.5 11.25a.333.333 0 100 .667.333.333 0 000-.667zm-1.333.333a1.333 1.333 0 112.666 0 1.333 1.333 0 01-2.666 0zM9.5 7.083a.333.333 0 100 .667.333.333 0 000-.667zm-1.333.334a1.333 1.333 0 112.666 0 1.333 1.333 0 01-2.666 0zM14.5 8.75a.333.333 0 100 .667.333.333 0 000-.667zm-1.333.333a1.333 1.333 0 112.666 0 1.333 1.333 0 01-2.666 0zM19.333 3a.333.333 0 100 .667.333.333 0 000-.667zM18 3.333a1.333 1.333 0 112.667 0 1.333 1.333 0 01-2.667 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.244 7.629a.5.5 0 01-.064.704l-3.719 3.101a.5.5 0 11-.64-.768l3.719-3.1a.5.5 0 01.704.063zM13.575 9.302L10.13 8.154l.317-.95 3.445 1.15-.316.948zM18.858 4.108c.17.162.19.445.044.633l-3.186 4.102a.38.38 0 01-.574.049.482.482 0 01-.044-.633l3.186-4.102a.38.38 0 01.574-.049z"
  }));
}

var _default = SvgUsage;
exports["default"] = _default;